var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInformationApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7906 12.8687L12.6719 16.9874L11.0531 15.3686L10.1719 16.25L12.6719 18.75L17.6719 13.75L16.7906 12.8687Z",
    fill: "#007A55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 12.5H5.17188V13.75H8.92188V12.5Z",
    fill: "#007A55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1719 10H5.17188V11.25H10.1719V10Z",
    fill: "#007A55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92188 2.5H8.92188V6.25C8.92188 6.93756 9.48431 7.5 10.1719 7.5H13.9219V11.25H15.1719V6.25C15.1719 6.06262 15.1093 5.9375 14.9844 5.81237L10.6094 1.43737C10.4844 1.31256 10.3594 1.25 10.1719 1.25H3.92188C3.23431 1.25 2.67188 1.81244 2.67188 2.5V17.5C2.67188 18.1876 3.23431 18.75 3.92188 18.75H8.29688V17.5H3.92188V2.5ZM10.1719 2.74994L13.6719 6.25H10.1719V2.74994Z",
    fill: "#007A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInformationApproved);
export default __webpack_public_path__ + "static/media/ic-information-approved.e1e7b0a0144ade1c18cb7be2a7302d6d.svg";
export { ForwardRef as ReactComponent };